import React from "react";

function CreatePostSection({ title, children, className = "", icon: Icon }) {
  return (
    <section className={`create-post-section-card ${className}`.trim()}>
      <div className="create-post-section-heading">
        <span
          className={`create-post-section-icon${Icon ? " create-post-section-icon--lucide" : " create-post-section-icon--dot"}`}
          aria-hidden="true"
        >
          {Icon ? <Icon size={16} strokeWidth={2.25} /> : null}
        </span>
        <h3>{title}</h3>
      </div>
      <div className="create-post-section-body">{children}</div>
    </section>
  );
}

export default CreatePostSection;
